export const directBookingsSettingsView = {
  loading: "Wczytywanie ustawień…",

  sidebar: {
    brandTitle: "Oferty",
    brandSub: "Panel ustawień",
    searchPlaceholder: "Szukaj…",
    generalLabel: "Ogólne",
    servicesName: "Usługi i atrakcje",
    servicesSub: "Jedna lista dla całego konta",
    promotionsName: "Promocje",
    promotionsSub: "Twórz · Edytuj · Zarządzaj",
    globalChip: "GLOBALNE",
    inactivePrefix: "Nieaktywna · {type}",
    unitsCount: "{count} jednostka | {count} jednostki | {count} jednostek",
    empty: "Brak obiektów.",
    listingFallbackName: "Oferta",
  },

  status: {
    active: "Aktywna",
    inactive: "Nieaktywna",
  },

  card: {
    unsavedChanges: "Niezapisane zmiany",
  },

  share: {
    title: "Link do rezerwacji bezpośredniej",
    hintPrefix: "Udostępnij link do oferty",
    hintSuffix: "i przyjmuj rezerwacje bez prowizji.",
    copyTitle: "Kopiuj link",
    viewAsVisitor: "Zobacz jako odwiedzający",
    copied: "Link skopiowany.",
    copyError: "Nie udało się skopiować linku.",
    whatsappText: "Cześć 👋 Oto link do rezerwacji: {link}",
  },

  savebar: {
    unsaved: "Niezapisane zmiany",
    noChanges: "Brak oczekujących zmian",
    saving: "Zapisywanie…",
  },

  drawer: {
    close: "Zamknij",
  },

  content: {
    selectListing: "Wybierz ofertę",
  },

  units: {
    pickerHint: "Włącz lub wyłącz widoczność każdej jednostki w rezerwacjach bezpośrednich albo otwórz ją, aby ją skonfigurować (ceny, zdjęcia, opis, usługi i opłaty).",
    visible: "Widoczna",
    hidden: "Ukryta",
    showTooltip: "Pokaż tę jednostkę w rezerwacjach bezpośrednich",
    configure: "Skonfiguruj",
  },

  header: {
    listingSub: "Oferta · {count} jednostka · rezerwacje bezpośrednie | Oferta · {count} jednostki · rezerwacje bezpośrednie | Oferta · {count} jednostek · rezerwacje bezpośrednie",
    unitSub: "Jednostka · konfiguracja indywidualna",
    unitSubCoded: "Jednostka {code} · konfiguracja indywidualna",
    hotelSub: "Hotel / Kemping · rezerwacje bezpośrednie",
    apartmentSub: "Apartament / Willa · rezerwacje bezpośrednie",
  },

  tabs: {
    reservations:       { label: "Widoczność oferty", sub: "Włącz ją i ustaw płatność oraz akceptację rezerwacji bezpośrednich" },
    units_list:         { label: "Jednostki",         sub: "Które jednostki można rezerwować" },
    common_images:      { label: "Części wspólne",    sub: "Wspólne zdjęcia budynku (okładka)" },
    rate_plans:         { label: "Ceny",              sub: "Widoczne plany cenowe" },
    images:             { label: "Zdjęcia",           sub: "Galeria oferty" },
    description:        { label: "Opis",              sub: "Tekst i szczegóły oferty" },
    services:           { label: "Usługi",            sub: "Usługi i udogodnienia" },
    promotions:         { label: "Promocje",          sub: "Jak wyświetlają się w tej ofercie" },
    addons:             { label: "Obłożenie",         sub: "Rabaty i dodatkowy gość" },
    age_rules:          { label: "Zasady dla gości",  sub: "Niemowlęta, dzieci i liczba osób" },
    additional_charges: { label: "Opłaty i podatki",  sub: "VAT, sprzątanie i opłaty" },
    web_embed:          { label: "Integracja ze stroną", sub: "Dodaj wyszukiwarkę na własnej stronie" },
  },

  save: {
    ratePlans: "Zapisz ceny",
    promotions: "Zapisz promocje",
    addons: "Zapisz opłaty",
    ageRules: "Zapisz zasady",
    additionalCharges: "Zapisz opłaty i podatki",
    payments: "Zapisz płatności",
    default: "Zapisz",
  },

  types: {
    apartment: "Apartament",
    house: "Dom",
    villa: "Willa",
    loft: "Loft",
    room: "Pokój",
    studio: "Studio",
    cabin: "Domek",
    hotel: "Hotel",
    hostel: "Hostel",
    camping: "Kemping",
  },

  toasts: {
    unitVisible: "Jednostka widoczna w rezerwacjach bezpośrednich.",
    unitHidden: "Jednostka ukryta.",
    unitUpdateError: "Nie udało się zaktualizować jednostki.",
  },

  errors: {
    noUserUuid: "Nie znaleziono UUID użytkownika.",
    loadPage: "Nie udało się wczytać strony.",
    loadContext: "Nie udało się wczytać kontekstu.",
    saveExec: "Nie udało się wykonać zapisu.",
    saveGeneric: "Nie udało się zapisać.",
  },

  misc: {
    propertyFallback: "Obiekt {id}",
  },
};
